<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-06 15:49:36
 * @LastEditTime: 2020-10-30 15:22:54
 * @LastEditors: Please set LastEditors
 -->
// 设备地图分布---组件
<template>
    <div class="mapbox">
        <!-- 地图容器 -->
        <div class="mapbox_main">
            <!-- 地图 -->
            <div class="mapDom" :id="'allmap' + domIdStr">
                <h3>地图显示</h3>
            </div>
        </div>
        <!-- 设备信息浮层 -->
        <div class="showBtn" @click="showAll">
            <el-button type="primary" size='small'>查看全部</el-button>
        </div>
        <div class="deviceInfoLayer" v-if="showFlag">
            <!-- 标题 -->
            <div class="titleDeviceInfo">
                <span class="paneltitle">设备信息</span>
                <span style="float: right; margin: 5px; cursor: default" v-on:click="closepanel">X</span>
            </div>
            <!-- 设备信息 -->
            <div class="deviceInfoMain" id="deviceinfo">
                <div class="class2">
                    <span class="class00 class02">名称</span>
                    <span class="class00 class03">ID</span>
                    <span class="class00 class04">状态</span>
                    <span class="class00 class05">地址</span>
                    <span class="class00" style="width:20px;float:left;margin-left:5px;"></span>
                </div>
                <div class="wgdzxx">
                    <div class="class2" :key="'a'+index" v-for="(item,index) in pointList">
                        <span class="class00 class02">{{item.gatewayName}}</span>
                        <span class="class00 class03">{{item.gatewayId}}</span>
                        <span class="class00 class04">
                            <span :class="`onLine${item.onlineFlag}`"></span>
                        </span>
                        <span class="class00 class05">{{item.address}}</span>
                        <span
                            style="width:60px;float:left;margin-left:5px;cursor:pointer"
                            @click="todevice(item)"
                        >查看</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// 引入工具类
import utils from '@/util/utilsHome';
var markerClustererTest = null
import { deviceListMapInfo } from '@/api/overview/bigScreen.js';
export default {
    name: 'deviceMap',
    // 父组件传来的参数
    props: [
        'domIdStr', // id追加的字符：目的是解决同一个页面同时使用多个此组件时，id相同问题
        'isSetCenter', // 是否根据设备点设置中心点
        'mapLevel' // 地图级别
    ],
    data() {
        return {
            // 地图展示相关
            arr: [], // 存放设备信息，并赋予title,deviceId,address等属性
            point: [], // 存放标注点经纬度信息
            marker: [], // 存放标注点对象
            mapObj: null, // 地图对象
            styleJson: [], // 个性化地图的json样式代码
            device: [], // 将经纬度相同的点存放在一个组里
            pointsimplify: [], // 存放删除了重复点的点数据
            clickEvent: 0, // 当前点击显示弹窗序号
            devpanelOnline: [], // 存储设备在线状态
            devicehtml: '1111', // 地图设备信息中标题的html代码
            pointList: [],
            showFlag: false,
            contactData: []
        };
    },
    created() {},

    mounted() {
        // 获取设备地图信息
        this.mapList();
    },
    watch: {
      qpMapShow: function (newVal) {
          if (newVal) {
            this.mapList();
          }
      }
    },
    methods: {
        showAll() {
            this.showFlag = !this.showFlag;
            this.pointList = this.device
        },
        /*
         * 方法函数
         */
        // 点击 地图展示的 全屏
        fullScreenClick() {
            utils.notificationInfo('提示', '开发中！', 'warning');
        },
        

        // 添加标注点和信息面板
        addmarkerandInfo: function () {
           let _this = this;
          this.mapObj = new BMap.Map("allmap" + this.domIdStr); // 创建Map实例
          this.mapObj.centerAndZoom(new BMap.Point(this.arr[0].lon, this.arr[0].lat), 10); // 初始化地图,设置中心点坐标和地图级别
          this.mapObj.enableScrollWheelZoom(true);//启用滚轮放大缩小
          this.mapObj.setCurrentCity("中国"); // 设置地图显示的城市 此项是必须设置的
          let mapStyle = 'midnight'  // 午夜蓝
          this.mapObj.setMapStyle({
            style: mapStyle
          })
        let clusterMarkers = []

        var markers = [];
        var pt = null;
        // console.log(this.contactData,'---contactData---')
        for (let i = 0; i < this.contactData.length; i++) {
        
          var point = new BMap.Point(this.contactData[i].lon, this.contactData[i].lat);
          let index = this.contactData[i].onlineFlag*1
          var myIcon = new BMap.Icon(require('@/assets/img/globalPage/icon1Status'+ this.contactData[i].onlineFlag*1+'.png'), new BMap.Size(47, 49))
          var marker = new BMap.Marker(point, { icon: myIcon })  // 创建标注
          markers.push(marker)
          var label = new BMap.Label(this.contactData[i].list.length, { offset: new BMap.Size(40, 8) });
          this.mapObj.addOverlay(marker)
          marker.setLabel(label)
          marker.addEventListener("click", function(e) {
            _this.showDivBox(_this.contactData[i])
          })
       
        //   label.setStyle({
        //     lineHeight: "25px",
        //     height: "23px",
        //     color: "red",
        //     left: '30px',
        //     padding: "0 ",
        //   })
          
        }

        this.mapObj.addEventListener("zoomend", function (res) {
          // _this.mapObj.clearOverlays()
          // console.log(_this.mapObj.getZoom(),'.getDemo.getDemozoomend handele')
        //   let curZoom = _this.mapObj.getZoom()
        //   let Clumarkers = []
        //    _this.moreMarkers()
        });

        
        // markerClustererTest = new BMapLib.MarkerClusterer(this.mapObj, {markers:markers});
         
        },
        
        moreMarkers() {
           let _this = this;
          var markers = [];
          for (let i = 0; i < this.contactData.length; i++) {
            if (!this.arr[i].list) {
              continue
            }
            var point = new BMap.Point(this.contactData[i].lon, this.contactData[i].lat);
            let index = this.contactData[i].onlineFlag*1
            var myIcon = new BMap.Icon(require('@/assets/img/globalPage/icon1Status'+ this.arr[i].onlineFlag*1+'.png'), new BMap.Size(47, 49))
            var marker = new BMap.Marker(point, { icon: myIcon })  // 创建标注
            markers.push(marker)
            var label = new BMap.Label(this.contactData[i].list.length, { offset: new BMap.Size(40, 8) });
            this.mapObj.addOverlay(marker)
            marker.setLabel(label)
            marker.addEventListener("click", function(e) {
              _this.showDivBox(_this.contactData[i])
            })
        
            label.setStyle({
              lineHeight: "25px",
              height: "23px",
              color: "red",
              left: '30px',
              padding: "0 ",
            })
            
          }
        },
        showDivBox(obj) {
            let that = this;
            this.showFlag = true;

            this.pointList = [];
            let ary = [];
            let findIndex = -1;
            let itemlat = obj.lat.toString().slice(0, 7);
            let itemlon = obj.lon.toString().slice(0, 8);
            findIndex = this.contactData.findIndex((key) => {
                return key.lat == itemlat && key.lon == itemlon;
            });
            this.pointList = this.contactData[findIndex].list;
        },
        todevice: function (obj) {
            let that = this;
            that.$store.dispatch('SetDefaultStationFun', obj).then((res) => {
                that.$emit('selectStation', obj);
                that.$router.push('/deviceOverview');
            });
        },

        // 关闭设备信息面板
        closepanel: function () {
            this.showFlag = false;
        },

        // 获取设备地图信息
        mapList() {
            deviceListMapInfo().then((res) => {
                if (res.data.code !== 200) {
                    utils.notificationInfo('错误提示', res.data.error);
                    return;
                }
                if (res.data.data) {
                    const data = res.data.data;
                    data.map((item) => {
                        item.location = JSON.parse(item.location);
                    });
                    this.device = data
                    let arr = [];
                    if (data.length > 0) {
                        data.map((item) => {
                            let obj = item.location;
                            obj.onlineFlag = item.onlineFlag;
                            let filterIndex = arr.findIndex((item) => {
                                return item.lat == obj.lat && item.lon == obj.lon;
                            });
                            if (!obj.list) {
                                obj.list = [];
                                obj.list.push(item);
                            } else {
                                arr[filterIndex].list.push(item);
                            }
                            arr.push(obj);
                        });

                        this.arr = arr;
                        let contactData = []
                        arr.forEach((item) => {
                            let itemlat = item.lat.toString().slice(0, 7);
                            let itemlon = item.lon.toString().slice(0, 8);
                            let findIndex = -1;
                            findIndex = contactData.findIndex((key) => {
                                return key.lat == itemlat && key.lon == itemlon;
                            });
                            // defaultMore.push(item.list[0]);
                            if (!contactData.length) {
                                contactData.push({
                                    lat: itemlat,
                                    lon: itemlon,
                                    onlineFlag: item.onlineFlag,
                                    list: [item.list[0]]
                                });
                            } else if (findIndex > -1) {
                                contactData[findIndex].list.push(item.list[0]);
                            } else {
                                contactData.push({
                                    lat: itemlat,
                                    lon: itemlon,
                                    onlineFlag: item.onlineFlag,
                                    list: [item.list[0]]
                                });
                            }
                        });
                        this.contactData = contactData;
                        this.addmarkerandInfo();
                        
                        
                    } else {
                        // 地图初始化
                        this.addmarkerandInfo();
                    }
                     this.addmarkerandInfo();
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.onLine0,
.onLine1 {
    width: 10px;
    height: 10px;
    background: chartreuse;
    display: inline-block;
    border-radius: 50%;
}
.onLine0 {
    background: #ccc;
}
.showBtn {
    position: absolute;
    left: 10px;
    bottom: 10px;
}
</style>
